import React from "react";
import { GridListTileBar } from "@material-ui/core";
import BarTileInfoGrid from "./BarTileInfoGrid";

const BarTileInfo = ({tile}) => {
  return <GridListTileBar titlePosition="bottom" title={<BarTileInfoGrid tile={tile}/>} />;
};

export default BarTileInfo;
